<template>
  <div class="mx-12 mt-8">
    <MobilePlanFlashOffer
      v-if="offer.baseOffer"
      :base-offer="offer.baseOffer"
      :offer
    />
  </div>

  <BouyguesOfferSelected v-if="selected" :offer />
</template>

<script setup lang="ts">
import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-partnerships/mobile-plan/types/mobile-plan-offers'

import MobilePlanFlashOffer from '~/scopes/partnerships/components/MobilePlanFlashOffer/MobilePlanFlashOffer.vue'

import BouyguesOfferSelected from './components/BouyguesOfferSelected/BouyguesOfferSelected.vue'

defineProps<{
  offer: MobilePlanOffer
  selected: boolean
}>()
</script>
